import React, {useEffect, useState, } from "react";
import { Tabs } from 'antd';
import { useDispatch } from 'react-redux';
import { getResources } from "../stateManagement/actions/data";
import { ADMIN_ACCESS } from "../utils/constants";
import PublishersList from "../components/sections/publishersList";
import WebsitesList from "../components/sections/websitesList";
import CustomRulesList from "../components/sections/rulesList";
import PlatformsList from "../components/sections/platformsList";

const ResourcesPage = () =>{
    const dispatch = useDispatch();
    const [resources, setResources] = useState({});
    const [reloader, setReloader] = useState(false);

    //Reload when updates
    const forceRerender = () => setReloader(prevState => !prevState);

    //Load the data
    useEffect(() => {
        dispatch(getResources(setResources))
    }, [dispatch, reloader]);

    //Filter publishers access
    const filteredPublishers = resources.publishers?.filter(i => i.returnedValue !== ADMIN_ACCESS)
        ?.map((i, index) => ({ ...i, key: index }));

    //Add keys to the websites    
    const websitesWithKeys = resources.websites?.map((i, index) => ({ ...i, key: index }));

    //Add keys to the platforms    
    const platformsWithKeys = resources.platforms?.map((i, index) => ({ ...i, key: index }));

    const items = [
        {
          key: '1',
          label: 'Publishers',
          children: <PublishersList list={filteredPublishers} reloadData={forceRerender} />,
        },
        {
          key: '2',
          label: 'Websites',
          children: <WebsitesList list={websitesWithKeys} publishersList={filteredPublishers} reloadData={forceRerender}/>,
        },
        {
          key: '3',
          label: 'Custom Rules',
          children: <CustomRulesList list={resources.rules} reloadData={forceRerender} />,
        },
        {
          key: '4',
          label: 'Platforms',
          children: <PlatformsList list={platformsWithKeys} reloadData={forceRerender} />,
        },
    ];

    return(<>
        <h2>Resources:</h2>
        <Tabs defaultActiveKey="1" type="card" items={items} />
    </>)
}

export default ResourcesPage;